import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function UserLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { Users } = useStore();
  const user = Users.get(id);
  return <div className={classNames({ [skeleton]: user.isPending }, className)}>{user.name}</div>;
}

export default observer(UserLabel);
